@if (label) {
  <label class="input-label" for="matTextarea">{{ label }}</label>
}
<mat-form-field appearance="outline" class="textarea-field">
  <textarea
    id="matTextarea"
    color="primary"
    matInput
    [ngStyle]="{ width: width + 'px' }"
    [required]="required"
    [formControl]="formControl"
    [placeholder]="placeholder">
  </textarea>
  <mat-error class="custom-error-container">
    <mat-icon class="custom-error-icon">error_outline</mat-icon>
    <span class="custom-error-text">{{ errorInput }}</span>
  </mat-error>
</mat-form-field>
